import '../sass/app.scss';

import $ from 'jquery';
import '../../../../node_modules/slick-carousel/slick/slick.min.js';
import './map.js';
import forms from './forms';

window.jQuery = $;
window.$ = $;

$(document).ready(function() {
  forms();

  $('.nav-item a[data-menu-id]').each(function() {
    if (
      !document.getElementById(
        $(this)
          .data('menu-id')
          .substring(1),
      )
    ) {
      $(this).removeAttr('data-menu-id');
    }
  });

  $('header.si-header button.hamburger').on('click', function() {
    $(this).toggleClass('is-active');

    if ($(this).hasClass('is-active')) {
      $('header.si-header').addClass('nav-active');
    } else {
      $('header.si-header').removeClass('nav-active');
    }
  });

  $('header.si-header .header-subnav.mobile-only .expand-subnav').on('click', function() {
    var alreadyOpen = false;

    if (
      $(this)
        .parent()
        .hasClass('subnav-active')
    ) {
      alreadyOpen = true;
    }

    $('header.si-header .header-subnav.mobile-only .subnav-item.subnav-active').removeClass(
      'subnav-active',
    );

    if (!alreadyOpen) {
      $(this)
        .parent()
        .addClass('subnav-active');
    }
  });

  $('header.si-header .header-nav .nav-item a').hover(
    function() {
      if ($(window).width() >= 768) {
        var menuId = $(this).data('menu-id');

        $(menuId).addClass('hover');
      }
    },
    function() {
      if ($(window).width() >= 768) {
        var menuId = $(this).data('menu-id');

        $(menuId).removeClass('hover');
      }
    },
  );

  $('header.si-header .desktop-header-subnav-menu').on('mouseover', function() {
    $(
      'header.si-header .header-nav .nav-item a[data-menu-id="#' +
        $(this)
          .parent()
          .attr('id') +
        '"]',
    ).addClass('hover');
    $(this)
      .parent()
      .addClass('hover');
  });

  $('header.si-header .desktop-header-subnav-menu').mouseout(function() {
    $(
      'header.si-header .header-nav .nav-item a[data-menu-id="#' +
        $(this)
          .parent()
          .attr('id') +
        '"]',
    ).removeClass('hover');
    $(this)
      .parent()
      .removeClass('hover');
  });

  $('header.si-header .desktop-header-subnav').click(function() {
    $(
      'header.si-header .header-nav .nav-item a[data-menu-id="#' + $(this).attr('id') + '"]',
    ).removeClass('hover');
    $(this).removeClass('hover');
  });

  $('header.si-header .header-search-form').submit(function(event) {
    event.preventDefault();

    if (
      $(this)
        .find('input[name="search"]')
        .val().length > 0
    ) {
      var locale = window.location.pathname.split('/');

      if (locale.length > 1) {
        locale = locale[1];
      }

      if (locale == 'es') {
        window.location =
          '/buscar/' +
          $(this)
            .find('input[name="search"]')
            .val();
      } else if (locale == 'fr') {
        window.location =
          '/rechercher/' +
          $(this)
            .find('input[name="search"]')
            .val();
      } else {
        window.location =
          '/search/' +
          $(this)
            .find('input[name="search"]')
            .val();
      }
    }
  });

  $('#fieldAccept').change(function(e) {
    $('.js-cm-submit-button').prop('disabled', !e.target.checked);
  });

  $('.js-cm-submit-button').prop('disabled', true);

  floatingBarCheckOffset();

  $('.timeline-component .year button').click(function() {
    var buttonElement = $(this)
      .parent()
      .next();

    $('.timeline-component .events').hide();

    if (buttonElement.css('display') == 'none') {
      buttonElement.show();
    } else {
      buttonElement.hide();
    }
  });

  $('.timeline-component .year')
    .eq(0)
    .find('button')
    .trigger('click');

  if ($('.project-component').data('theme') == 'brown' || $('.blog-post-event-details').data('theme') == 'brown') {
    $('body')
      .removeClass('green-theme' || 'blue-theme')
      .addClass('brown-theme');
  }

  if ($('.project-component').data('theme') == 'blue' || $('.blog-post-event-details').data('theme') == 'blue') {
    $('body')
      .removeClass('green-theme' || 'brown-theme')
      .addClass('blue-theme');
  }


  $('.modal .modal-close').click(function() {
    $(this)
      .parents('.modal')
      .removeClass('modal-open');
  });

  $('[data-modal]').click(function() {
    $($(this).data('modal')).addClass('modal-open');
  });

  var twitterDom = $('#shared-interest-latest-tweet');
  var sharedInterestTwitterLatestTweet = {
    profile: { screenName: 'sharedinterest' },
    domId: 'shared-interest-latest-tweet',
    maxTweets: 1,
    enableLinks: true,
    showUser: false,
    showTime: false,
    showImages: false,
    showRetweet: false,
    showInteraction: false,
    lang: 'en',
  };

  if (twitterDom.length) {
    twitterFetcher.fetch(sharedInterestTwitterLatestTweet);
  }
});

$(document).scroll(function() {
  floatingBarCheckOffset();
});

function floatingBarCheckOffset() {
  if ($('.floating-bar').length > 0) {
    if (
      $('.floating-bar').offset().top + $('.floating-bar').height() >=
      $('.si-footer').offset().top - 10
    ) {
      $('.floating-bar').removeClass('floating-bar-fixed');
    }

    if ($(document).scrollTop() + window.innerHeight < $('.si-footer').offset().top) {
      $('.floating-bar').addClass('floating-bar-fixed'); // restore when you scroll up
    }
  }
}



// WEBPACK FOOTER //
// ./themes/app/assets/js/app.js